<template>
 <v-dialog v-model="show" persistent max-width="400px">
       <v-card>
        <v-toolbar
          color="yellow lighten-1"
          dark
        >

          <v-toolbar-title   class="headline">EHT-Schema</v-toolbar-title>
 <v-spacer></v-spacer>

          <!-- <v-btn icon>
            <v-icon>circle_notifications</v-icon>
          </v-btn> -->
        </v-toolbar>

<div v-if="membersInfo.length==0">
  <div class="h3"> Ingen i elevhälsan har lagt in information om sina arbetstider eller hur de arbetar, uppmuntra dem till att göra det!</div>
</div>
<div v-else>
 <v-list two-line>
            <v-subheader>Arbetstider:</v-subheader>
          <template v-for="item in membersInfo">
           <v-list-tile :key="item.title" avatar >
              <v-list-tile-avatar>
                     <v-icon class="rounded-circle">{{getIcon(item.role)}}</v-icon>

              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title>
                        <v-tooltip bottom v-for="day in updateDays(days,item)" :key="day.text">
                            
        <template  v-slot:activator="{ on, attrs }">
                          
                    <v-btn  v-if="day.workday==true" v-bind="attrs"   v-on="on"  fab dark small :color="day.color" >
     {{day.text}}
    </v-btn>
     </template>
                          <span v-if="day.workday==true">{{
                             day.workinghours
                            }}
                            </span >
                            
                        </v-tooltip>
          
                   </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>


 <v-subheader>Beskrivning:</v-subheader>
     <v-flex v-for="item in membersInfo"  :key="item.title">
           <div class="title ml-4" v-html="item.title" ></div>
            
          <p class="ml-4">
                  {{item.description}}
            </p>
          </v-flex>
</div>

                      <v-btn dark color="blue darken-1" @click="show = false">
                Stäng
              </v-btn>
      </v-card>

 </v-dialog>
</template>
<script>
import fun from "../functions";
import { mapActions,mapGetters } from "vuex";
export default {
    name:"Schedule",

  computed: {
    
    ...mapGetters('ehtmembers', ['membersInfo']),
    show: {
      get () {

        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },
  created(){
       this.locfun= new fun();

  },
    props:{
        value: Boolean
    },
data() {
    return {
      locfun:null,
      dialog:false,
      counter:0,
      days:[{text: "Mån", color:"pink" ,value:0},{text: "Tis", color:"green",value:1},{text: "Ons", color:"orange",value:2},{text: "Tor", color:"red",value:3},{text: "Fre", color:"blue",value:4}],
      items: [
        { workdays: [0,1,2],workinghours: ["14","12","12"], title: 'Maria,Sjuksköterska'},
        { workdays: [0,3,4],workinghours: ["11:10-11:20","14:20-17:20","12:10-15:20"], title: 'Sara,Sjuksköterska'},
        { workdays: [3,4],workinghours: ["08:40-15:20","09:40-15:20"], title: 'Olga,Sjuksköterska'},
       ]
    };
  },
  methods: {

DaytoInt(day){
  if (day=="Måndag") {
    return 0;
  }
    else if (day=="Tisdag") {
    return 1;
  }
    else if (day=="Onsdag") {
    return 2;
  }
   else if (day=="Torsdag") {
    return 3;
  }
return 4
},

getIcon(role)
{
  if (role=="skolsköterska" ||role=="skolläkare") {
    return 'favorite';
  }
  else  if ( role=="kurator" || role=="skolpsykolog") {
    return 'psychology';
  }
  else   if (role=="syv") {
    return 'engineering';
  }
  
  return 'school'
},

      updateDays(days,item)
      {
       let workdays=item.workdays.map(day => this.DaytoInt(day) )
       
for (let i = 0; i < workdays.length; i++) {
    days[workdays[i]].workday=true;
    days[workdays[i]].workinghours=item.workinghours[i];
    
}
return days
      },
   updateCounter(item,index)
   {
       if (index==0) {
           this.counter=-1;
       }
       
       if (item.workdays.includes(index)) {
           this.counter++;
           return true;
       }
    return false;
       
   },
   
}
}
</script>
<style >
.h3{
margin: 5%;


}
.round{
    border: 1px solid black;
    border-radius: 30;
}
</style>